var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',_vm._g(_vm._b({staticClass:"list-menu-item"},'li',_vm.$attrs,false),_vm.$listeners),[_c('a',{attrs:{"href":"#"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }